(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    class FinalSaleNote extends HTMLElement {
    connectedCallback() {
      const form = document.forms[this.getAttribute('form')];
      if (!form) return;

      this._form = form;
      this._onVariantChange = this.onVariantChange.bind(this);
      form.addEventListener('variant:change', this._onVariantChange);
    }

    disconnectedCallback() {
      this._form?.removeEventListener('variant:change', this._onVariantChange);
    }

    onVariantChange(event) {
      const variant = event.detail.variant;
      this.hidden = !(variant['compare_at_price'] > variant['price']);
    }
  }

  if (!customElements.get('final-sale-note')) {
    customElements.define('final-sale-note', FinalSaleNote);
  }
  } catch(e) { console.error(e); }
})();

})();
